import styled from 'styled-components';

const Section = styled.section`
  margin-top: ${(props): string => props.theme.spaces.xxl};
  border: solid 0.1rem ${(props): string => props.theme.colors.heatherGray};
  border-radius: ${(props): string => props.theme.borderRadius.normal};
  box-shadow: ${(props): string => props.theme.boxShadow.default};
  background-color: ${(props): string => props.theme.colors.pureWhite};
`;

export { Section };
